export const MODAL_TYPES = {
    LOCAL_STAGING_API_REQUEST_WARN: 'LOCAL_STAGING_API_REQUEST_WARN',
    LOCAL_STAGING_RETAILER_SWITCH_WARN: 'LOCAL_STAGING_RETAILER_SWITCH_WARN',
    LOGIN_FAILURE: 'LOGIN_FAILURE',
    PRODUCT_IMAGES: 'PRODUCT_IMAGES',
    PRODUCT_COPY_UNSAVED_WARNING: 'PRODUCT_COPY_UNSAVED_WARNING',
    PRODUCT_CHANGED_MODAL: 'PRODUCT_CHANGED_MODAL',
};
